import { toNormalizedMessage } from '@/shared/utils/sentry/clientIgnoreRules/stringMatchers';
import { ClientSentryIgnoreRule } from '@/shared/utils/sentry/clientIgnoreRules/types';

const EXPECTED_ABORT_MESSAGES = [
  'aborterror: fetch is aborted',
  'fetch is aborted',
] as const;

const MS_HEADER_FILENAME_MARKER =
  'assets/shared-assets/ui/v2/webpack/js/msheader';
const SELLER_UI_APP_FRAME_MARKERS = [
  'webpack://_n_e/./src/',
  'webpack://_n_e/src/',
  '/_next/static/chunks/',
] as const;

const hasExpectedAbortMessage = (message: unknown): boolean => {
  const normalizedMessage = toNormalizedMessage(message);
  return Boolean(
    normalizedMessage &&
    EXPECTED_ABORT_MESSAGES.some(
      (expectedMessage) => normalizedMessage === expectedMessage
    )
  );
};

const hasMsHeaderStackFrame = (stackFrameFilenames: string[]): boolean =>
  stackFrameFilenames.some((filename) =>
    toNormalizedMessage(filename)?.includes(MS_HEADER_FILENAME_MARKER)
  );

const hasSellerUiAppStackFrame = (stackFrameFilenames: string[]): boolean =>
  stackFrameFilenames.some((filename) => {
    const normalizedFilename = toNormalizedMessage(filename);

    return Boolean(
      normalizedFilename &&
      SELLER_UI_APP_FRAME_MARKERS.some((marker) =>
        normalizedFilename.includes(marker)
      )
    );
  });

export const thirdPartyMsHeaderAbortErrorRule: ClientSentryIgnoreRule = {
  id: 'third-party-ms-header-abort-error',
  references: ['FTR-2881'],
  reason:
    'Known third-party msHeader abort browser noise outside seller-ui app code',
  matches: ({
    firstExceptionType,
    originalExceptionMessage,
    serializedMessage,
    stackFrameFilenames,
  }) => {
    if (firstExceptionType !== 'AbortError') {
      return false;
    }

    if (
      !hasExpectedAbortMessage(serializedMessage) &&
      !hasExpectedAbortMessage(originalExceptionMessage)
    ) {
      return false;
    }

    if (hasSellerUiAppStackFrame(stackFrameFilenames)) {
      return false;
    }

    return hasMsHeaderStackFrame(stackFrameFilenames);
  },
};
